import { compose } from '@reduxjs/toolkit';
import { fetchBranchesReducer } from './branches/fetchAllBranches';
import { fetchBranchCustomerExclusionReducer } from './branches/fetchBranchCustomersExclusion';
import { toggleBranchCreditReducer } from './branches/toggleBranchCredit';
import { toggleBranchPurchaseLimitReducer } from './branches/toggleBranchPurchaseLimit';
import { toggleBranchUserDataUpdateReducer } from './branches/toggleBranchUserData';
import { updateBranchReducer } from './branches/updateBranch';
import { upsertBranchCustomerExclusionReducer } from './branches/upsertBranchCustomersExclusion';

export const extraReducers = compose(
  fetchBranchesReducer,
  fetchBranchCustomerExclusionReducer,
  updateBranchReducer,
  toggleBranchPurchaseLimitReducer,
  toggleBranchCreditReducer,
  upsertBranchCustomerExclusionReducer,
  toggleBranchUserDataUpdateReducer,
);

export { fetchAllBranches } from './branches/fetchAllBranches';
export { fetchBranchCustomersExclusion } from './branches/fetchBranchCustomersExclusion';
export { toggleBranchCredit } from './branches/toggleBranchCredit';
export { toggleBranchPurchaseLimit } from './branches/toggleBranchPurchaseLimit';
export { updateBranch } from './branches/updateBranch';
export { upsertBranchCustomersExclusion } from './branches/upsertBranchCustomersExclusion';
